(function () {
  'use strict';

  if (window.OhCrispHomepageLoaded) return;
  window.OhCrispHomepageLoaded = true;

  document.documentElement.classList.add('ohc-js');

  var HORIZONTAL_RAIL_SELECTOR = '[data-ohc-rail], .ohc-gallery, .ohc-origin-grid, .ohc-chip-list, .ohc-grid';

  function initReveal(scope) {
    var items = scope.querySelectorAll('.ohc-reveal:not([data-ohc-reveal])');
    if (!items.length) return;

    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      items.forEach(function (item) {
        item.dataset.ohcReveal = 'true';
        item.classList.add('is-visible');
      });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });

    items.forEach(function (item) {
      item.dataset.ohcReveal = 'true';
      observer.observe(item);
    });
  }

  function warmHorizontalRail(rail) {
    if (!rail || rail.closest('[hidden]')) return;

    var railRect = rail.getBoundingClientRect();
    if (!railRect.width || !railRect.height) return;

    var preloadLeft = railRect.left - railRect.width * 0.25;
    var preloadRight = railRect.right + railRect.width * 1.15;

    rail.querySelectorAll('img:not([data-ohc-rail-warmed])').forEach(function (image) {
      var imageRect = image.getBoundingClientRect();
      if (!imageRect.width || imageRect.right < preloadLeft || imageRect.left > preloadRight) return;

      image.dataset.ohcRailWarmed = 'true';
      if (image.getAttribute('loading') === 'lazy') image.setAttribute('loading', 'eager');
      if (typeof image.decode === 'function' && !image.complete) image.decode().catch(function () {});
    });
  }

  function activateHorizontalRail(rail) {
    if (!rail || rail.closest('[hidden]')) return;
    warmHorizontalRail(rail);

    if (rail.dataset.ohcRailScrollReady) return;
    rail.dataset.ohcRailScrollReady = 'true';
    var frame = 0;
    rail.addEventListener('scroll', function () {
      if (frame) return;
      frame = window.requestAnimationFrame(function () {
        frame = 0;
        warmHorizontalRail(rail);
      });
    }, { passive: true });
  }

  function initHorizontalRails(scope) {
    var rails = Array.prototype.slice.call(scope.querySelectorAll(HORIZONTAL_RAIL_SELECTOR));
    if (scope.matches && scope.matches(HORIZONTAL_RAIL_SELECTOR)) rails.unshift(scope);

    rails.forEach(function (rail) {
      if (rail.dataset.ohcHorizontalReady) return;
      rail.dataset.ohcHorizontalReady = 'true';

      if (!('IntersectionObserver' in window)) {
        activateHorizontalRail(rail);
        return;
      }

      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          activateHorizontalRail(rail);
          observer.disconnect();
        });
      }, { rootMargin: '800px 0px', threshold: 0 });

      observer.observe(rail);
    });
  }

  function initWays(section) {
    if (section.dataset.ohcWaysReady) return;
    section.dataset.ohcWaysReady = 'true';
    var tabs = Array.prototype.slice.call(section.querySelectorAll('[data-ohc-tab]'));
    var panels = Array.prototype.slice.call(section.querySelectorAll('[data-ohc-panel]'));
    if (!tabs.length || !panels.length) return;
    var preloadObserver = null;

    function getPanelImage(id) {
      var panel = panels.find(function (candidate) {
        return candidate.dataset.ohcPanel === id;
      });
      return panel && panel.querySelector('[data-ohc-way-media] img');
    }

    function warmImage(image, priority) {
      if (!image) return;

      if (priority && image.getAttribute('fetchpriority') !== priority) {
        image.setAttribute('fetchpriority', priority);
      }
      if (image.dataset.ohcWayWarmed) return;

      image.dataset.ohcWayWarmed = 'true';
      if (image.getAttribute('loading') === 'lazy') image.setAttribute('loading', 'eager');
      if (typeof image.decode === 'function' && !image.complete) {
        image.decode().catch(function () {});
      }
    }

    function warmPanel(id, priority) {
      warmImage(getPanelImage(id), priority);
    }

    function scheduleIdle(callback) {
      if ('requestIdleCallback' in window) {
        window.requestIdleCallback(callback, { timeout: 750 });
        return;
      }
      window.setTimeout(callback, 150);
    }

    function preloadInactiveImages() {
      if (preloadObserver) {
        preloadObserver.disconnect();
        preloadObserver = null;
      }
      if (!section.isConnected || section.dataset.ohcWaysPreloaded) return;
      section.dataset.ohcWaysPreloaded = 'true';

      var queue = panels.slice(1).map(function (panel) {
        return panel.querySelector('[data-ohc-way-media] img');
      }).filter(Boolean);

      section.querySelectorAll('[data-ohc-way-sticker] img').forEach(function (image) {
        queue.push(image);
      });

      function warmNext() {
        if (!section.isConnected || !queue.length) return;
        queue.splice(0, 2).forEach(function (image) {
          warmImage(image, 'low');
        });
        if (queue.length) scheduleIdle(warmNext);
      }

      scheduleIdle(warmNext);
    }

    function deferInactivePreload() {
      if ('IntersectionObserver' in window) {
        preloadObserver = new IntersectionObserver(function (entries) {
          if (!entries.some(function (entry) { return entry.isIntersecting; })) return;
          preloadInactiveImages();
        }, { rootMargin: '900px 0px', threshold: 0 });
        preloadObserver.observe(section);
      }

      if (document.readyState === 'complete') {
        scheduleIdle(preloadInactiveImages);
        return;
      }
      window.addEventListener('load', function () {
        scheduleIdle(preloadInactiveImages);
      }, { once: true });
    }

    function select(id) {
      tabs.forEach(function (tab) {
        var active = tab.dataset.ohcTab === id;
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
        tab.setAttribute('tabindex', active ? '0' : '-1');
      });
      panels.forEach(function (panel) {
        panel.hidden = panel.dataset.ohcPanel !== id;
      });
    }

    tabs.forEach(function (tab, index) {
      function warmSelectedPanel() {
        warmPanel(tab.dataset.ohcTab, 'high');
      }

      tab.addEventListener('pointerenter', warmSelectedPanel, { passive: true });
      tab.addEventListener('focus', warmSelectedPanel);
      tab.addEventListener('touchstart', warmSelectedPanel, { passive: true });
      tab.addEventListener('click', function () {
        warmSelectedPanel();
        select(tab.dataset.ohcTab);
      });
      tab.addEventListener('keydown', function (event) {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        var direction = event.key === 'ArrowRight' ? 1 : -1;
        var nextIndex = (index + direction + tabs.length) % tabs.length;
        warmPanel(tabs[nextIndex].dataset.ohcTab, 'high');
        tabs[nextIndex].focus();
        select(tabs[nextIndex].dataset.ohcTab);
      });
    });
    select(tabs[0].dataset.ohcTab);
    deferInactivePreload();
  }

  function initCarousel(section) {
    if (section.dataset.ohcCarouselReady) return;
    section.dataset.ohcCarouselReady = 'true';
    var rail = section.querySelector('[data-ohc-rail]');
    if (!rail) return;
    section.querySelectorAll('[data-ohc-scroll]').forEach(function (button) {
      button.addEventListener('click', function () {
        var direction = Number(button.dataset.ohcScroll) || 1;
        var card = rail.querySelector('.ohc-single, .ohc-review');
        var styles = window.getComputedStyle(rail);
        var gap = parseFloat(styles.columnGap || styles.gap) || 0;
        var distance = card ? card.getBoundingClientRect().width + gap : 260;
        rail.scrollBy({ left: direction * distance, behavior: 'smooth' });
      });
    });
  }

  function initGallery(section) {
    if (section.dataset.ohcGalleryReady) return;
    section.dataset.ohcGalleryReady = 'true';
    var dialog = section.querySelector('[data-ohc-dialog]');
    var dialogImage = dialog && dialog.querySelector('img');
    if (!dialog || !dialogImage || typeof dialog.showModal !== 'function') return;

    section.querySelectorAll('[data-ohc-gallery-image]').forEach(function (button) {
      button.addEventListener('click', function () {
        var image = button.querySelector('img');
        if (!image) return;
        dialogImage.src = button.dataset.ohcGalleryFull || image.currentSrc || image.src;
        dialogImage.alt = image.alt || '';
        dialog.showModal();
      });
    });

    var close = dialog.querySelector('[data-ohc-dialog-close]');
    if (close) close.addEventListener('click', function () { dialog.close(); });
    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) dialog.close();
    });
  }

  function initMap(section) {
    if (section.dataset.ohcMapReady) return;
    section.dataset.ohcMapReady = 'true';
    var islands = Array.prototype.slice.call(section.querySelectorAll('[data-ohc-island]'));
    var panels = Array.prototype.slice.call(section.querySelectorAll('[data-ohc-region]'));
    if (!islands.length || !panels.length) return;

    function select(region) {
      islands.forEach(function (island) {
        island.setAttribute('aria-pressed', island.dataset.ohcIsland === region ? 'true' : 'false');
      });
      panels.forEach(function (panel) {
        var active = panel.dataset.ohcRegion === region;
        panel.hidden = !active;
        if (active) panel.querySelectorAll(HORIZONTAL_RAIL_SELECTOR).forEach(activateHorizontalRail);
      });
    }

    islands.forEach(function (island) {
      island.addEventListener('click', function () { select(island.dataset.ohcIsland); });
      island.addEventListener('keydown', function (event) {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        select(island.dataset.ohcIsland);
      });
    });
    select(islands[0].dataset.ohcIsland);
  }

  function init(root) {
    var scope = root || document;
    initHorizontalRails(scope);
    initReveal(scope);
    scope.querySelectorAll('[data-ohc-ways]').forEach(initWays);
    scope.querySelectorAll('[data-ohc-carousel]').forEach(initCarousel);
    scope.querySelectorAll('[data-ohc-gallery]').forEach(initGallery);
    scope.querySelectorAll('[data-ohc-map]').forEach(initMap);
  }

  function findThemeEditorBlock(section, event) {
    var blockId = event.detail && event.detail.blockId;
    var eventTarget = event.target instanceof Element ? event.target : null;

    if (eventTarget) {
      var targetBlock = eventTarget.closest('[data-shopify-editor-block]');
      if (targetBlock && section.contains(targetBlock)) return targetBlock;
    }

    if (!blockId) return null;
    return Array.prototype.find.call(
      section.querySelectorAll('[data-shopify-editor-block]'),
      function (block) {
        var value = block.getAttribute('data-shopify-editor-block');
        if (value === blockId || block.dataset.blockId === blockId) return true;
        if (!value) return false;
        try {
          return JSON.parse(value).id === blockId;
        } catch (error) {
          return false;
        }
      }
    ) || null;
  }

  function revealThemeEditorBlock(event) {
    var eventTarget = event.target instanceof Element ? event.target : null;
    if (!eventTarget) return;

    var section = eventTarget.closest('.ohc') || eventTarget.querySelector('.ohc');
    if (!section) return;

    var block = findThemeEditorBlock(section, event);
    if (!block) return;

    function bringIntoView() {
      window.requestAnimationFrame(function () {
        var hiddenParent = block.closest('[hidden]');
        var target = hiddenParent || block;
        if (target.hasAttribute && target.hasAttribute('hidden')) target = section;
        target.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'center' });
      });
    }

    if (section.matches('[data-ohc-ways]')) {
      var tab = block.matches('[data-ohc-tab]') ? block : block.closest('[data-ohc-tab]');
      if (!tab) {
        var wayPanel = block.closest('[data-ohc-panel]');
        if (wayPanel) {
          tab = Array.prototype.find.call(section.querySelectorAll('[data-ohc-tab]'), function (candidate) {
            return candidate.dataset.ohcTab === wayPanel.dataset.ohcPanel;
          });
        }
      }
      if (tab) tab.click();
      bringIntoView();
      return;
    }

    if (section.matches('[data-ohc-map]')) {
      var panel = block.closest('[data-ohc-region]');
      if (panel) {
        var island = Array.prototype.find.call(section.querySelectorAll('[data-ohc-island]'), function (candidate) {
          return candidate.dataset.ohcIsland === panel.dataset.ohcRegion;
        });
        if (island) island.click();
      }
    }
    bringIntoView();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });

  document.addEventListener('shopify:block:select', revealThemeEditorBlock);
})();
